export default __webpack_public_path__ + "static/media/button-bg.3dd84037.svg";